// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"5a9a4c6a","53":"bb385ce0","875":"b37fad64"}[chunkId] + ".chunk.js";
};